<template>
  <dl
    class="clearfix bg-blue-box p15 mt15"
    :class="{'is-open':isOpen}"
  >
    <job-preview-right-column
      :text-count-mode="textCountMode"
      :highlight-mode="highlightMode"
      comment-class="sub"
      :comment-highlights="commentHighlights"
      v-on="$listeners"
    />
    <template
      v-if="isBulkRegistrationAddress"
    >
      <dt>【{{ title }}】</dt>
      <dd
        :id="placeId"
        class="pega-pre-wrap"
        data-test="requirements-combined-all-bulk-place"
        v-text="value"
      />
    </template>

    <template
      v-if="!isBulkRegistrationAddress"
    >
      <dt>【{{ title }}】</dt>
      <dd
        :id="placeId"
        class="clearfix"
        :class="{'shorten':showToggleButton && !isOpen}"
        data-test="requirements-work-location"
        v-text="value"
      />
      <div
        v-if="showToggleButton"
        class="job-location-accordion"
        data-test="toggle"
      >
        <p @click="togglePlaceText">
          {{ buttonText }}
        </p>
      </div>
    </template>
  </dl>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/offer/base" as *;
</style>

<script>
import JobPreviewRightColumn from '@/components/molecules/JobPreviewRightColumn'
import * as definition from '@/lib/highlightMappings'

export default {
  components: {
    JobPreviewRightColumn
  },
  props: {
    commentHighlights: {
      type: Array,
      default: () => []
    },
    highlightMode: {
      type: Boolean,
      required: true
    },
    textCountMode: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    isBulkRegistrationAddress: {
      type: Boolean,
      default: false
    },
    placeId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      locationTextHeight: 0,
      isOpenWorkLocation: false
    }
  },
  computed: {
    targetIdMap: () => definition.targetIdMap,
    showToggleButton () {
      return this.locationTextHeight > 50
    },
    hasHighlight () {
      return this.commentHighlights.some(i => i.highlight)
    },
    buttonText () {
      return this.isOpen ? '勤務地エリアを閉じる' : '勤務地エリアをすべて見る'
    },
    isOpen () {
      // 以下の場合は常にtrueを返却する(開く)
      // - トグルボタン非表示の時
      // - ハイライトモードで、ハイライトが存在する時
      //   - ハイライト作成時や、ハイライトモード切り替え時に自動で開く
      if (this.highlightMode && this.hasHighlight) {
        this.setIsOpenWorkLocation(true)
      }
      // 上記以外の場合のみ、toggle操作に紐づく値を見る
      return this.isOpenWorkLocation
    }
  },
  mounted () {
    this.$set(this, 'locationTextHeight', document.getElementById(this.placeId).offsetHeight)
  },
  methods: {
    setIsOpenWorkLocation (val) {
      this.$set(this, 'isOpenWorkLocation', val)
    },
    togglePlaceText () {
      // ハイライトがない場合のみ開閉可能（省略エリアにハイライトされるとUIおかしくなるので）
      if (!this.isOpenWorkLocation || !this.highlightMode || !this.hasHighlight) {
        this.setIsOpenWorkLocation(!this.isOpenWorkLocation)
        return
      }
      this.$toasted.global.error({ message: 'ハイライトがあるため、エリアを閉じることはできません。' })
    }
  }
}
</script>
